import { render } from "./Save.vue?vue&type=template&id=44a4e92b&scoped=true"
const script = {}

import "./Save.vue?vue&type=style&index=0&id=44a4e92b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a4e92b"]])

export default __exports__